import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import { FiltersDropdown } from '@shared/components/ui/FiltersDropdown';
import { Search } from '@shared/components/ui/Search';
import { ColumnSelector } from '@shared/components/ui/ColumnSelector';
import { ColumnDef } from '@tanstack/react-table';
import { ChangeEvent, useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PreInvoicesFiltersPanel } from './PreInvoicesFiltersPanel';

interface FiltersSectionProps {
  handleSearch: (value: string) => void;
  onFilterChange?: (conditions: FilterConditionOutput[]) => void;
  columns: ColumnDef<any>[];
  selectedColumns: string[];
  onColumnsChange: (newSelected: string[]) => void;
  filterConditions: FilterConditionOutput[];
  searchTerm: string;
}

export const FiltersSection = ({
  handleSearch,
  onFilterChange,
  columns,
  selectedColumns,
  onColumnsChange,
  filterConditions,
  searchTerm,
}: FiltersSectionProps) => {
  const { t } = useTranslation('preInvoicesModule');
  const [inputValue, setInputValue] = useState(searchTerm);

  useEffect(() => {
    setInputValue((prev) => (prev === searchTerm ? prev : searchTerm));
  }, [searchTerm]);

  const handleFilterChange = useCallback(
    (conditions: FilterConditionOutput[]) => {
      onFilterChange?.(conditions);
    },
    [onFilterChange],
  );

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleSearchSubmit = () => {
    handleSearch(inputValue.trim());
  };

  const activeFiltersCount = filterConditions.length;

  return (
    <>
      <Search
        placeholder={t('search.placeholder')}
        value={inputValue}
        onChange={handleInputChange}
        onEnter={handleSearchSubmit}
        dataTestId="search"
        inputDataTestId="search-input"
      />
      <FiltersDropdown
        title={t('filters.filters', 'Filtros')}
        triggerLabel={t('filters.filters', 'Filtros')}
        activeFiltersCount={activeFiltersCount}
        triggerTestId="pre-invoices-filters-toggle"
      >
        <PreInvoicesFiltersPanel initialConditions={filterConditions} onChange={handleFilterChange} />
      </FiltersDropdown>
      <ColumnSelector
        columns={columns}
        selected={selectedColumns}
        onColumnsChange={onColumnsChange}
        storageKey="pre-invoices-list-columns"
      />
    </>
  );
};
